import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";

import { Select } from "../../components/ui";

interface LabelInputContainerProps {
  label?: React.ReactNode;
  hint?: React.ReactNode;
  children: React.ReactNode;
}

export const LabelInputContainer: React.FC<LabelInputContainerProps> = ({
  label,
  hint,
  children,
}) => {
  const [id] = useState(uuidv4());
  const childrenWithProps = React.Children.map(children, (child) =>
    // @ts-ignore: not sure how to get the right type here
    React.cloneElement(child, { id: id, key: id }),
  );

  return (
    <div className="flex items-center text-sm">
      <label htmlFor={id}>{label}</label>
      <div>{childrenWithProps}</div>
      {hint && <span>{hint}</span>}
    </div>
  );
};

interface SelectDropdownProps {
  label?: React.ReactNode;
  hint?: React.ReactNode;
  items: Record<string, string>;
  defaultValue?: string;
  onChange?: React.ChangeEventHandler;
  className?: string;
}

export const SelectDropdown: React.FC<SelectDropdownProps> = (props) => {
  const { label, hint, items, ...rest } = props;

  const optionElems = Object.keys(items).map((item) => (
    <option key={item} value={item}>
      {items[item]}
    </option>
  ));

  // @ts-ignore
  const selectElem = <Select {...rest}>{optionElems}</Select>;

  return label ? (
    <LabelInputContainer label={label} hint={hint}>
      {selectElem}
    </LabelInputContainer>
  ) : (
    selectElem
  );
};
